import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { DownloadSecurityContainerWindowData } from '../types/download-security-container-data';

export abstract class DownloadSecurityContainerBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getDownloadSecurityContainerData(): Promise<DownloadSecurityContainerWindowData>;

  public abstract getDownloadSecurityContainerLinks(packageId: string): Promise<DownloadSecurityContainerWindowData>;
}
